import {fetchPollSharing} from '../../../api'
import type {DeliveryIds} from '../../../api/definitions/form'
import {EventGoal} from '../../../lib/metrika'
import type {AppConfig} from '../../../types'

/** Количество перезапросов в шарилку при ошибках нетворка/500 */
const SHARING_REQUEST_RETRIES = 3

/**
 * Создаёт коллбэк, вызываемый после успешного создания заказа.
 */
export const getAcceptOfferSuccessHandler =
  ({
    clearDraftValues,
    onLoadingStatusChange,
    onReachGoal,
    showError,
    sharingProvider = 'cargo-claims',
    config,
  }: {
    /** Метод для удаления данных драфтового заказа из persistent storage */
    clearDraftValues: VoidFunction
    /** Коллбэк, вызываемый при изменении признака, что происходит выполнение запроса */
    onLoadingStatusChange: (isLoading: boolean) => void
    /** Метод для отправки данных в Метрику */
    onReachGoal: (goal: EventGoal) => void
    /** Метод для показа ошибки */
    showError: (error?: Error) => void
    /** Провайдер для получения шарилки */
    sharingProvider?: string
    config: AppConfig
  }) =>
  (data: DeliveryIds) => {
    const deliveryId = data.delivery_ids?.[0]

    if (!deliveryId) {
      showError()
      return
    }

    onLoadingStatusChange(true)

    return fetchStoreLastOrderId(deliveryId)
      .then(() =>
        fetchPollSharing(
          config,
          {
            order_id: deliveryId,
            order_provider_id: sharingProvider,
          },
          SHARING_REQUEST_RETRIES,
        ),
      )
      .then(sharing => fetchRemoveLastOrderId().then(() => sharing.body.sharing_url))
      .then(url => {
        console.log(url)
        if (!url) {
          return
        }
        onReachGoal(EventGoal.SuccessOrderCreate)
        clearDraftValues()
        window.location.href = url
      })
      .catch(showError)
      .finally(() => {
        onLoadingStatusChange(false)
      })
  }

export async function fetchStoreLastOrderId(orderId: string) {
  window.localStorage.setItem('lastOrderId', orderId)
  return orderId
}

export async function fetchRemoveLastOrderId() {
  window.localStorage.removeItem('lastOrderId')
  return null
}
